import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "Do franchisees need their own marketing beyond corporate?",
    "a": "Yes — corporate marketing is brand-level and brings general awareness. Local pipeline comes from local SEO, your unit's GBP, and local PPC tuned to your service area."
  },
  {
    "q": "Are we allowed to do our own marketing under brand guidelines?",
    "a": "Usually yes — most franchise systems allow local marketing within brand guidelines. We work with your corporate marketing team to ensure compliance while filling your local pipeline."
  },
  {
    "q": "What about multi-unit operators?",
    "a": "Multi-unit operators benefit even more — each unit gets its own GBP, local pages, and local ads. Across a region, this stacks into significant competitive advantage."
  },
  {
    "q": "Is SEO worth it for a franchise unit?",
    "a": "Yes — your unit competes with other units of the same brand and with competing brands locally. SEO is the difference between winning the call or not."
  },
  {
    "q": "Do you market service-based franchises (cleaning, pest, restoration, fitness)?",
    "a": "Yes — service franchises especially benefit because every call matters. We've helped service franchises across home services, fitness, restoration, and more."
  }
];

export const Route = createFileRoute("/franchise-marketing-colorado")({
  head: () =>
    industryMarketingHead("Franchise", "franchise business", "franchise-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Franchise"}
      industryLower={"franchise business"}
      slug={"franchise-marketing-colorado"}
      subheadline={"We help Colorado franchise operators — single-unit and multi-unit — drive local pipeline that corporate marketing alone can't fill."}
      painPoints={["Corporate marketing brings brand awareness but no local pipeline","Your unit's Google Business Profile is underbuilt vs. competitor units","You can't differentiate within the brand on price or service alone"]}
      serviceDescriptions={{
        seo: "Rank locally for your franchise category and service area — beyond what corporate SEO covers.",
        googleMaps: "Own 'your franchise category near me' in the local Map Pack so your unit wins the call.",
        webDesign: "Local landing pages and microsites that complement corporate sites with unit-specific lead capture.",
        ppc: "Local Google Ads tuned to your service area and unit-specific offers within brand guidelines.",
        geoAi: "Get cited when buyers ask ChatGPT for 'best [your category] in [your city]' so they pick your unit specifically.",
        socialMedia: "Unit-specific local content that builds community and drives repeat customers.",
      }}
      testimonial={{"quote":"We outperform every other unit in the region. Corporate brings the brand; local marketing fills the schedule.","role":"Multi-Unit Franchise Owner","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Franchise marketing in Colorado Springs","description":"Local franchise marketing across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Franchise marketing in Denver","description":"Multi-unit and single-unit franchise marketing across Denver."},{"to":"/boulder-digital-marketing","label":"Franchise marketing in Boulder","description":"Franchise marketing across Boulder and Northern Colorado."}]}
    />
  ),
});
